export default __webpack_public_path__ + "static/media/birthday_card.68b088f5.png";